// Mirrors the backend rule in legacy-api validators/passwordreset.js
// and the auth-service meter (auth-service/public/js/password-strength.js).
export const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9 ])[\S]{8,}$/;
export const PASSWORD_REQUIREMENT =
  'At least 8 characters, including an uppercase letter, a number, and a special character.';
